import type { LucideProps } from 'lucide-react'

import { cn } from 'src/shared/utils/cn'

type TabBarIconButtonProps = {
  icon: (props: LucideProps) => React.ReactNode
  isActive: boolean
  onClick: () => void
}

const TabIconButton = ({ icon, isActive, onClick }: TabBarIconButtonProps) => {
  const Icon = icon
  return (
    <button
      className={cn(
        'flex h-[45px] w-[45px] flex-row items-center justify-center gap-1.5 rounded-full bg-white/10 text-[#c6cbc9] transition-all duration-200 hover:bg-white/20',
        isActive && 'bg-white/25',
      )}
      onClick={onClick}
    >
      <div className="flex shrink-0 items-center justify-center rounded-[10px] transition-all duration-200">
        <Icon className={cn(isActive && 'text-white')} />
      </div>
    </button>
  )
}

export default TabIconButton
